import { Parsing } from "./parsing";

class SkText extends Parsing {
  exp: any;
  constructor(
    private elem: HTMLElement,
    private attr: string,
    private module: any
  ) {
    super();
    this.exp = Parsing.expression(attr);
    this.update();
  }

  update(): void {
    const value = this.exp.call(this.module);
    this.elem.innerText = value || null;
  }
}

export { SkText };
